export interface FeatureFlags {
  challenges: boolean
  tundraForecast: boolean
  fleetTemperatureForecast: boolean
}

function parseFlagEnv(value: string | undefined): boolean {
  if (value === undefined) return true
  const normalized = value.trim().toLowerCase()
  return normalized !== 'false' && normalized !== '0'
}

export const featureFlags: FeatureFlags = {
  challenges: parseFlagEnv(import.meta.env.VITE_FF_CHALLENGES),
  // Tundra-readiness forecast overlay (ModelFactory integration). Default ON
  // as a kill switch (set VITE_FF_TUNDRA_FORECAST=false to disable): the
  // overlay is data-driven and renders nothing unless the API has the
  // MODELFACTORY_* config AND the site has a forecast in the cache, so the
  // flag being on is inert everywhere the backend is not wired.
  tundraForecast: parseFlagEnv(import.meta.env.VITE_FF_TUNDRA_FORECAST),
  // Fleet Temperature Forecaster overlay (ModelFactory integration). Default ON
  // as a kill switch (set VITE_FF_FLEET_TEMPERATURE_FORECAST=false to disable):
  // cache-only and data-driven -- renders nothing unless the API has the
  // MODELFACTORY_* config AND the site has a pre-computed forecast in the
  // cache, so the flag being on is inert everywhere the backend is not wired.
  fleetTemperatureForecast: parseFlagEnv(
    import.meta.env.VITE_FF_FLEET_TEMPERATURE_FORECAST,
  ),
}

export function isFeatureEnabled(flagName?: keyof FeatureFlags): boolean {
  if (!flagName) return true
  return featureFlags[flagName]
}
